import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { faClose, faPencilAlt, faSave } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  deleteInvoiceProduct,
  getTaxRates,
  updateInvoice,
} from 'client/utils/api-routes-invoice'
import _ from 'lodash'
import {
  DcButton,
  DcDiv,
  DcSwitch,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
  PixelTooltip,
  colors,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import { env } from 'shared/env'

import LineItem from './LineItem'
import { IPixelFactory } from '../../../../../../decl.d'

const dummyLineItem = {
  product_id: -1,
  variation_id: 0,
  image: '',
  sku: '',
  stock_quantity: '',
  sell_price: '',
  total: 0,
  quantity: 1,
  price: 0,
  tax: 0,
}
const filterDummy = (d) => d.product_id !== -1

const filterDeleted = (d) => !d.is_deleted
const LineItems = (props) => {
  const {
    detailID,
    setDetails,
    details,
    newInvoice,
    saveLineItems,
    setSaveLineItems,
  } = props

  const baseURL = env.SERVER_ADDR

  const gotoPrint = () => {
    window.open(getPrintLink(), '_blank')
  }
  const getPrintLink = () => {
    const { token } = JSON.parse(
      localStorage.getItem('user_info') || '{token: null}',
    )
    return `${baseURL}api/v2/print/invoice/${token}/${detailID}`
  }
  const { showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [editing, setEditing] = React.useState(newInvoice || false)
  const [applySales, setApplySales] = React.useState(false)
  const [localLineItems, setLocalLineItems] = React.useState<any>([])
  const [removedLineItems, setRemoveLineItems] = React.useState<any>([])
  const [taxRates, setTaxRates] = React.useState<any>({})
  const [taxApplied, setTaxApplied] = React.useState(false)

  const resetLineItems = () => {
    setLocalLineItems(
      props.details.line_items.map((i) => {
        i.is_deleted = false
        return i
      }),
    )
  }

  React.useEffect(() => {
    if (props.details.line_items && !newInvoice) {
      setLocalLineItems(props.details.line_items)
    }
    if (
      props.details?.shipping?.postcode &&
      taxRates.zip !== props.details?.shipping?.postcode
    ) {
      setTaxRates({
        ...taxRates,
        zip: props.details?.shipping?.postcode,
      })
      getAllTaxRates()
    } else {
      setTaxRates({
        ...taxRates,
        error: taxRates?.total_rate
          ? false
          : 'Please enter a valid zip code in the customer section.',
      })
    }
  }, [props])

  React.useEffect(() => {
    if (newInvoice) {
      setDetails({
        ...details,
        line_items: localLineItems,
        tempLineItems: localLineItems,
      })
    }
  }, [localLineItems])

  React.useEffect(() => {
    if (saveLineItems === 'closeToPagination') {
      setEditing(false)
      setSaveLineItems('')
    } else if (saveLineItems === 'savetoPrint') {
      saveInvoiceData()
    }
  }, [saveLineItems])

  const getAllTaxRates = () => {
    getTaxRates(props.details?.shipping?.postcode).subscribe(
      (res: AjaxResponse<any>) => {
        setTaxRates({
          ...res.response?.data,
          postcode: props.details.shipping.postcode,
          error:
            res.response?.data === null
              ? 'No tax rate available for this zip code.'
              : false,
        })
      },
    )
  }
  const addLineItem = (index: number, action: string) => {
    if (action === 'push') {
      setLocalLineItems([...localLineItems, { ...dummyLineItem }])
    } else {
      if (applySales && taxRates?.total_rate) {
        setTaxApplied(true)
        const item = { ...dummyLineItem }
        item.total = item.price * item.quantity
        item.tax = item.total * taxRates.total_rate
        const newLocalLineItems = [...localLineItems]
        newLocalLineItems.splice(index, 0, { ...item, sku: 'Custom' })
        setLocalLineItems(newLocalLineItems)
        return
      }
      const newLocalLineItems = [...localLineItems]
      newLocalLineItems.splice(index, 0, { ...dummyLineItem, sku: 'Custom' })
      setLocalLineItems(newLocalLineItems)
    }
  }

  const removeLineItem = (item, index) => {
    if (item.product_id === -1 || item.product_id === 0) {
      setRemoveLineItems([...removedLineItems, { ...item }])
      const newLocalLineItems = [...localLineItems]
      newLocalLineItems[index].is_deleted = true
      newLocalLineItems.splice(index, 1)
      setLocalLineItems(newLocalLineItems)
    } else {
      const item = localLineItems[index]
      setRemoveLineItems([...removedLineItems, { ...item }])
      const newLocalLineItems = [...localLineItems]
      newLocalLineItems[index].is_deleted = true
      newLocalLineItems.splice(index, 1)
      setLocalLineItems(newLocalLineItems)
    }
  }
  React.useEffect(() => {
    if (editing) {
      addLineItem(localLineItems.length + 1, 'push')
    } else {
      setLocalLineItems(localLineItems.filter((d) => d.product_id !== -1))
    }
  }, [editing])

  React.useEffect(() => {
    if (applySales && taxRates?.total_rate && !taxApplied) {
      applyTaxRate()
    } else if (!applySales && taxApplied) {
      removeTaxRate()
    }
  }, [taxRates, applySales])

  const applyTaxRate = () => {
    setTaxApplied(true)
    const items = [...localLineItems].map((item) => {
      item.total = item.price * item.quantity
      item.tax = item.total * taxRates.total_rate
      return item
    })
    setLocalLineItems(items)
  }

  const removeTaxRate = () => {
    const items = [...localLineItems].map((item) => {
      item.total = item.price * item.quantity
      item.tax = 0
      return item
    })
    setLocalLineItems(items)
    setTaxApplied(false)
  }

  const updateLineItem = (item, index) => {
    const newLocalLineItems = [...localLineItems]
    newLocalLineItems[index] = item
    setLocalLineItems(newLocalLineItems)
  }
  const setNewProduct = (product, index) => {
    const newLocalLineItems = [...localLineItems]
    const item = { ...product }
    if (applySales && taxRates?.total_rate) {
      setTaxApplied(true)
      item.total = item.price * item.quantity
      item.tax = item.total * taxRates.total_rate
    }
    newLocalLineItems[index] = { ...item }
    if (!newLocalLineItems.find((d) => d.product_id === -1)) {
      newLocalLineItems.push({ ...dummyLineItem })
    }
    setLocalLineItems(newLocalLineItems)
  }
  const ref = React.useRef(null)
  const saveInvoiceData = () => {
    if (editing) {
      setEditing(false)
      showPageLoader()
      const id = details.invoice_id || details.number
      deleteInvoiceProduct(
        id,
        _.map(removedLineItems, 'source_lineitem_id'),
      ).subscribe(() => {
        updateInvoice(id, {
          line_items: localLineItems.filter(filterDeleted).filter(filterDummy),
        }).subscribe((res: AjaxResponse<any>) => {
          if (res.response.data) {
            setDetails(res.response?.data)
            setEditing(false)
            if (saveLineItems === 'savetoPrint') {
              gotoPrint()
              setSaveLineItems('')
            }
          }
          hidePageLoader()
        })
      })
    } else if (saveLineItems === 'savetoPrint') {
      gotoPrint()
      setSaveLineItems('')
    }
  }

  const restoreItem = (index) => {
    const newLocalLineItems = [...localLineItems]
    newLocalLineItems[index].is_deleted = false
    setLocalLineItems(newLocalLineItems)
  }

  return (
    <PixelDiv ref={ref}>
      <PixelFlexBox style={{ justifyContent: 'space-between' }}>
        <PixelFlexBox>
          <PixelText
            style={{
              fontWeight: '600',
              padding: '10px',
              color: 'rgba(0, 0, 0, 0.84)',
            }}
          >
            Products
          </PixelText>
        </PixelFlexBox>
        <PixelFlexBox
          gap={'10px'}
          justifyContent={'flex-end'}
          style={{ padding: '10px 10px 0px 0px' }}
        >
          {!newInvoice ? (
            <>
              {editing ? (
                <>
                  <DcDiv width="auto">
                    <OverlayTrigger
                      placement={'top'}
                      overlay={
                        <Tooltip id={`tooltip-${'top'}`}>
                          {taxRates.error ? taxRates.error : ''}
                          {!taxRates.error &&
                            localLineItems.filter(filterDummy).length === 0 &&
                            'No products added'}
                        </Tooltip>
                      }
                    >
                      <DcSwitch
                        size="sm"
                        onChange={(e) => {
                          setApplySales(e.target.checked)
                        }}
                        disabled={
                          !!taxRates.error ||
                          localLineItems.filter(filterDummy).length === 0
                        }
                        checked={applySales}
                        label={
                          applySales ? 'Remove Sales Tax' : 'Apply Sales Tax'
                        }
                      />
                    </OverlayTrigger>
                  </DcDiv>

                  <DcButton
                    size="sm"
                    showTooltip={true}
                    tooltip="Save"
                    onClick={saveInvoiceData}
                    variant="link"
                  >
                    <FontAwesomeIcon icon={faSave} />
                  </DcButton>
                  <DcButton
                    showTooltip={true}
                    tooltip="Cancel"
                    size="sm"
                    variant="link"
                    onClick={() => {
                      setEditing(false)
                      resetLineItems()
                    }}
                  >
                    <FontAwesomeIcon icon={faClose} />
                  </DcButton>
                </>
              ) : (
                <>
                  {details?.invoice_status === 'open' ? (
                    <DcButton
                      size="sm"
                      variant="link"
                      onClick={() => {
                        setEditing(true)
                      }}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </DcButton>
                  ) : (
                    <DcButton
                      size="sm"
                      variant="link"
                      color="lightgrey"
                      style={{
                        cursor: 'not-allowed',
                      }}
                    >
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </DcButton>
                  )}
                </>
              )}
            </>
          ) : (
            <PixelTooltip
              tooltipText={
                <>
                  {taxRates.error ? taxRates.error : ''}
                  {!taxRates.error &&
                    localLineItems.filter(filterDummy).length === 0 &&
                    'No products added'}
                </>
              }
            >
              <DcSwitch
                size="sm"
                onChange={(e) => {
                  setApplySales(e.target.checked)
                }}
                disabled={
                  !!taxRates.error ||
                  localLineItems.filter(filterDummy).length === 0
                }
                checked={applySales}
                label={applySales ? 'Remove Sales Tax' : 'Apply Sales Tax'}
              />
            </PixelTooltip>
          )}
        </PixelFlexBox>
      </PixelFlexBox>
      <PixelFlexBox
        style={{
          justifyContent: 'space-between',
          padding: '10px',
          background: colors.primaryLight,
          fontWeight: 'bold',
          marginTop: '10px',
        }}
      >
        <PixelText style={{ fontWeight: '400', fontSize: '12px' }} width="50%">
          Items
        </PixelText>
        <PixelFlexBox width="50%" justifyContent="space-around">
          <PixelText
            style={{ fontWeight: '400', fontSize: '12px' }}
            width="10%"
          >
            QTY
          </PixelText>
          <PixelText
            style={{ fontWeight: '400', fontSize: '12px' }}
            width="20%"
          >
            Price
          </PixelText>
          <PixelText
            style={{ fontWeight: '400', fontSize: '12px' }}
            width="20%"
          >
            Total
          </PixelText>
        </PixelFlexBox>
      </PixelFlexBox>
      <PixelFlexBox
        style={{
          flexDirection: 'column',
          width: '100%',
          borderRadius: '0 0 5px 5px',
          minHeight: '100px',
        }}
      >
        {localLineItems.map((item: any, i) => {
          return (
            <React.Fragment key={i}>
              <LineItem
                editing={editing}
                setEditing={setEditing}
                id={details.invoice_id || details.number}
                setDetails={setDetails}
                setSaveLineItems={setSaveLineItems}
                saveLineItems={saveLineItems}
                removedLineItems={removedLineItems}
                item={item}
                addLineItem={addLineItem}
                index={i}
                localLineItems={localLineItems}
                removeLineitem={removeLineItem}
                updateItem={updateLineItem}
                setNewProduct={setNewProduct}
                restoreItem={restoreItem}
              />
            </React.Fragment>
          )
        })}
      </PixelFlexBox>
    </PixelDiv>
  )
}

export default LineItems
